import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ls-page-header',
  templateUrl: './page-header.component.html',
})
export class PageHeaderComponent {}
